import React from 'react'
import { base_url } from '../api/index'

function LoadedFile({ file, id, onRemoveFile, remove }) {
  const url = `${base_url}file/${file.src}/${file.name}`
  return (
    <div className='loaded-file d-flex align-center mb-4'>
      <a href={url} target='_blank' rel='noopener noreferrer' className='green--text'>{file.name}</a>
      {remove !== false &&
        <div className='bin-button' onClick={() => onRemoveFile(id)}>
          <img src={`https://hcvf.ru/sites/all/themes/hcvf2/js/auth/icons/bin.svg`} alt='Удалить' />
        </div>
      }
    </div>
  )
}

export default LoadedFile